import React from "react";
import RevealAnimation from "../RevealAnimation";
import { FiArrowRight } from "react-icons/fi";

// Shared skeleton behind GrowRyteCTASection and VentureRyteCTASection - each
// keeps its own scss file (its own class name still drives the styling), so
// only the duplicated JSX and copy get parameterized here.
const PracticeCTASection = ({
  sectionClassName,
  id,
  heading,
  subtitle,
  welcomeText,
  buttonLabel,
  onPrimaryClick,
}) => (
  <section className={sectionClassName} id={id}>
    <div className="container">
      <RevealAnimation>
        <div className="cta-content">
          <h2>{heading}</h2>
          <p className="subtitle">{subtitle}</p>
          <p className="welcome-text">{welcomeText}</p>

          <div className="cta-buttons">
            <button className="btn-primary" onClick={onPrimaryClick}>
              {buttonLabel} <FiArrowRight />
            </button>
          </div>
        </div>
      </RevealAnimation>
    </div>
  </section>
);

export default PracticeCTASection;
